module.exports = __webpack_public_path__ + "static/assets/28482f29400304953d3865a5db1f8ffb.png";